import * as React from "react";
import { Grid, Button } from "components/controls/widget";
import { useApplication, getPdfUrl } from "../store";
import { ApplicationDetailComponent } from "../detail-component/view";


const View = () => {

    const [{ entity }] = useApplication();

    return <Grid container direction="column" spacing={8}>
        <Grid item>
            <ApplicationDetailComponent application={entity} />
        </Grid>
        <Grid item>
            <Button color="primary" variant="contained" href={getPdfUrl(entity.id, entity.hashCode, entity.clubId)}>{'Tisk přihlášky'}</Button>
        </Grid>
    </Grid>
}

export {
    View as ApplicationPage
}
